export default __webpack_public_path__ + "static/media/edit_icon.8fbfab05.svg";